import listActions from 'src/modules/funcion/list/funcionListActions';
import FuncionService from 'src/modules/funcion/funcionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'FUNCION_DESTROY';

const funcionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: funcionDestroyActions.DESTROY_STARTED,
      });

      await FuncionService.destroyAll([id]);

      dispatch({
        type: funcionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.funcion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: funcionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: funcionDestroyActions.DESTROY_ALL_STARTED,
      });

      await FuncionService.destroyAll(ids);

      dispatch({
        type: funcionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.funcion.destroyAll.success'),
      );

      getHistory().push('/funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: funcionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default funcionDestroyActions;
